import React from 'react';

import classNames from 'classnames';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

import TextButton from 'components/application/buttons/TextButton';
import Tooltip from 'components/application/Tooltip';

export default function ShowFooter({
  children,
  deleteDisabled,
  deleteDisabledTooltip,
  deleteText,
  editDisabled,
  editDisabledTooltip,
  editText,
  isCompact,
  isDeleteButtonHidden,
  isEditButtonHidden,
  onDeleteClick,
  onEditClick,
}) {
  const { t: i18nTShared } = useTranslation('common', {
    keyPrefix: 'shared',
  });

  return (
    <>
      {!isEditButtonHidden && (
        <div
          className={classNames(
            'tooltip-parent',
            editDisabled && 'tooltip-parent--disallowed',
          )}
        >
          <div
            className={classNames(
              'tw-border-0 tw-border-t-1 tw-border-solid tw-border-grey-100',
              isCompact ? 'tw-h-12' : 'tw-h-14.5',
            )}
          >
            <TextButton
              color='blue'
              disabled={editDisabled}
              onClick={onEditClick}
              size='full'
            >
              {editText || i18nTShared('editDetails')}
            </TextButton>
          </div>
          {editDisabled && (
            <Tooltip
              className={classNames(isCompact ? 'pos-t-12' : 'pos-t-16')}
              placement='top'
              tooltip={editDisabledTooltip}
              trigger='hover'
            />
          )}
        </div>
      )}
      {children}
      {!isDeleteButtonHidden && (
        <div
          className={classNames(
            'tooltip-parent',
            deleteDisabled && 'tooltip-parent--disallowed',
          )}
        >
          <div
            className={classNames(
              'tw-border-0 tw-border-t-1 tw-border-solid tw-border-grey-100',
              isCompact ? 'tw-h-12' : 'tw-h-14.5',
            )}
          >
            <TextButton
              color='red'
              disabled={deleteDisabled}
              onClick={onDeleteClick}
              size='full'
            >
              {deleteText || i18nTShared('delete')}
            </TextButton>
          </div>
          {deleteDisabled && (
            <Tooltip
              className={classNames(isCompact ? 'tw-top-3' : 'tw-top-4')}
              placement='top'
              tooltip={deleteDisabledTooltip}
              trigger='hover'
            />
          )}
        </div>
      )}
    </>
  );
}

ShowFooter.propTypes = {
  deleteDisabled: PropTypes.bool,
  deleteDisabledTooltip: PropTypes.string,
  deleteText: PropTypes.string,
  editDisabled: PropTypes.bool,
  editDisabledTooltip: PropTypes.string,
  editText: PropTypes.string,
  onDeleteClick: PropTypes.func,
  onEditClick: PropTypes.func.isRequired,
};

ShowFooter.defaultProps = {
  deleteDisabled: false,
  editDisabled: false,
  isCompact: false,
  isDeleteButtonHidden: false,
  isEditButtonHidden: false,
};
